import { useEffect, useState } from "react";
import LazyLoad from 'react-lazyload';
import { getBirthdays } from "../Service/Api";
import Slider from "react-slick";
const Birthday = () => {
  const [data, setData] = useState([]); 
  useEffect(() => {
   const fetchData = async () => {
     try {
       const data = await getBirthdays(); 
       setData(data);
     } catch (error) {
       console.error("Error fetching Birthdays Data:", error);
     }  
   };
   fetchData();
 }, []);


  var settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };
  return (
    <>
      <div className="row" id="Birthdays">
        <Slider {...settings}>
          {data.length > 0 ? data.map((item, index) => (
            <div className="item" key={index}>
              <div className="topperdiv birthday">
                <div className="toppertaj">
              <LazyLoad>    {item.attachments.length > 0 ? (<img src={`https://webapi.entab.info/api/image?url=${item.attachments}`} className="img-fluid" alt="Sacred Heart School Balia" />):(<img alt="Sacred Heart School Balia" src="https://webapi.entab.info/api/image/SHSSB/public/Images/Default.png" className="img-fluid" />)}</LazyLoad>
                </div>
                <div className="topperdesc">
                  <p className="name">{item.name}</p>
                  <p className="per">{item.class}</p>
                </div>
              </div>
            </div>
          )) : (
          <div className="item">
          <div className="topperdiv birthday"> 
          <div class="title"><h2>DD.MM</h2></div>
            <div className="toppertaj">
            <LazyLoad>  <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/Default.png" className="img-fluid" alt="Sacred Heart School Balia" /></LazyLoad>
            </div>
            <LazyLoad><img src="https://webapi.entab.info/api/image/SHSSB/public/Images/cake.png" className="cake_img" /></LazyLoad>
            <div className="topperdesc">
              <p className="name">Student Name</p>
              <p className="per">Class</p>
            </div>
          </div>
        </div>
        )} 
        </Slider>
      </div>
    </>
  )
}

export default Birthday